import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "logs-page-difference" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_JsonEditor = _resolveComponent("JsonEditor")!
  const _component_el_empty = _resolveComponent("el-empty")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.currentParameter)
      ? (_openBlock(), _createBlock(_component_JsonEditor, {
          key: 0,
          "json-data": _ctx.currentParameter
        }, null, 8 /* PROPS */, ["json-data"]))
      : (_openBlock(), _createBlock(_component_el_empty, {
          key: 1,
          description: "No data"
        }))
  ]))
}